import React, { useState } from 'react';
import imagenHome from '../../images/Banner_principal.png';
import logoNav from '../../images/logo_Suburbia_Visa.png';

export const Banner = () => {
	return (

		<div className="hero">
			<div className="nav">
                <img src={logoNav} alt="Suburbia Visa logo" />
			</div>
			<div className="portada">
				<img src={imagenHome} alt="Liverpool Visa logo" />
			</div>
		</div>

		
	);
	
};

